import AppStatsContainer from './AppStats'
export default AppStatsContainer



// WEBPACK FOOTER //
// ./src/containers/AppStats/index.js